import Axios from "axios";
import {
    SET_PUR_REQUISITION_REPORT,
    UNSET_PUR_REQUISITION_REPORT,
  } from "@/store/mutation-types";
import {getPurRequisitionReport} from "@/store/api";

const state = {
    getPurRequisitionReport: [],
};

const getters = {
    getPurRequisitionReport(state) {
        return state.getPurRequisitionReport;
    },
};

const mutations = {
    [SET_PUR_REQUISITION_REPORT](state, data) {
        state.getPurRequisitionReport = data;
    },
    [UNSET_PUR_REQUISITION_REPORT](state) {
        state.getPurRequisitionReport = [];
    },
};

const actions = {
    getPurRequisitionReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getPurRequisitionReport}`, { params: data })
                .then((response) => {
                    commit(SET_PUR_REQUISITION_REPORT, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_REQUISITION_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};